// Single shared email validator. Several components (EmailColleaguesForm,
// InviteOthersForm, FolderInviteForm, ContractorManagement) each redefine an
// equivalent regex inline — this is the one new call sites should use.
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * @param {string} [email]
 * @returns {boolean} Whether `email` (after trimming) looks like a valid address.
 *   Never throws on null/undefined/non-string input.
 */
export function isValidEmail(email) {
  return EMAIL_REGEX.test((email ?? '').trim());
}
